import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit'; // Importing from `utils` makes them more type-safe ✅
import { JobsState } from './types';
import {useInjectReducer} from "redux-injectors";

// The initial state of the Jobs page
export const initialState: JobsState = {
    jobs: [],
    isLoading: false,
};

const slice = createSlice({
    name: 'jobs',
    initialState,
    reducers: {
        updateJobs(state, action: PayloadAction<any>) {
            // Here we say lets change the username in my homepage state when changeUsername actions fires
            // Type-safe: It will expect `string` when firing the action. ✅
            // @ts-ignore
            state.jobs = action.payload;
        },
        deleteJob(state, action: PayloadAction<any>) {
            console.log(action);
            // @ts-ignore
            state.jobs = state.jobs.filter(item => item.uuid !== action.payload);
        },
        updateJobRatingLocally(state, action: PayloadAction<any>) {
            // @ts-ignore
            state.jobs = state.jobs.map(item => item.uuid === action.payload.uuid ? {...item, rating: action.payload.rating} : item);
        },
    },
});

/**
 * Let's turn this into a hook style usage. This will inject the slice to redux store and return actions in case you want to use in the component
 */
export const useJobsSlice = () => {
    useInjectReducer({ key: slice.name, reducer: slice.reducer });
    return { actions: slice.actions };
};